import { Cross, getScreenSizes } from '@pretamanger/component-library'
import { useAllergensQuery } from '#src/auth/my-account-page/hooks/use-allergens-query'
import useMedia from 'react-use/lib/useMedia'
import { useGetTranslation } from '#src/auth/my-account-page/hooks/use-get-translation'
import {
  FilterAllergensPillsContainer,
  WrapperFilterApplied,
  LabelFilter,
  LabelFilterApplied,
  WrapperPills,
  WrapperPill,
  LabelPill,
  LabelClear,
  WrapperLabel,
  ButtonClear,
  WrapperFilterMobile
} from './styles'

const FilterPill = ({ label, onClick }) => {
  return (
    <WrapperPill>
      <LabelPill>{label}</LabelPill>
      <button data-testid={`${label}-button`} onClick={() => onClick(label)}>
        <Cross colour={'grey-700'} height={12} width={12} />
      </button>
    </WrapperPill>
  )
}

const FilterPills = ({ list, onRemove, type }) => {
  const onClick = name => onRemove(name, type)
  return (
    <WrapperPills>
      {list?.map((label, index) => {
        return <FilterPill key={index} label={label} onClick={onClick} />
      })}
    </WrapperPills>
  )
}

const FilterAllergensPills = () => {
  const {
    updateFilterMultipleQuery,
    updateFilterQuery,
    arrSuitables: suitables,
    arrAllergens: allergens
  } = useAllergensQuery()
  const getTranslation = useGetTranslation()
  const text = {
    labelFilter: getTranslation('filter-allergens-label-filter'),
    labelVegan: getTranslation('filter-allergens-label-vegan'),
    labelDoesNotContain: getTranslation('filter-allergens-does-not-contain'),
    labelClearAll: getTranslation('filter-allergens-label-clear-all')
  }
  const isMobileView = useMedia(`(max-width: ${getScreenSizes().sm - 1}px)`)

  const onRemove = (name, type) => {
    updateFilterQuery({
      type,
      name,
      action: 'remove'
    })
  }

  const clearAll = () => {
    updateFilterMultipleQuery({ allergens: '', suitables: '' })
  }

  if (suitables?.length === 0 && allergens?.length === 0) {
    return <></>
  }

  if (isMobileView) {
    return (
      <FilterAllergensPillsContainer>
        <WrapperFilterMobile>
          <WrapperLabel>
            <LabelFilter>{text.labelFilter}:</LabelFilter>
          </WrapperLabel>
          <WrapperLabel>
            <ButtonClear onClick={clearAll} data-testid='clear-all-button'>
              <LabelClear>{text.labelClearAll}</LabelClear>
            </ButtonClear>
          </WrapperLabel>
        </WrapperFilterMobile>
        {suitables?.length !== 0 && (
          <WrapperFilterApplied>
            <WrapperLabel>
              <LabelFilterApplied>{text.labelVegan}</LabelFilterApplied>
            </WrapperLabel>
            <FilterPills
              list={suitables}
              onRemove={onRemove}
              type='suitables'
            />
          </WrapperFilterApplied>
        )}
        {allergens?.length !== 0 && (
          <WrapperFilterApplied>
            <WrapperLabel>
              <LabelFilterApplied>
                {text.labelDoesNotContain}
              </LabelFilterApplied>
            </WrapperLabel>
            <FilterPills
              list={allergens}
              onRemove={onRemove}
              type='allergens'
            />
          </WrapperFilterApplied>
        )}
      </FilterAllergensPillsContainer>
    )
  }

  return (
    <FilterAllergensPillsContainer>
      <WrapperLabel>
        <LabelFilter>{text.labelFilter}:</LabelFilter>
      </WrapperLabel>
      {suitables?.length !== 0 && (
        <WrapperFilterApplied>
          <WrapperLabel>
            <LabelFilterApplied>{text.labelVegan}</LabelFilterApplied>
          </WrapperLabel>
          <FilterPills list={suitables} onRemove={onRemove} type='suitables' />
        </WrapperFilterApplied>
      )}
      {allergens?.length !== 0 && (
        <WrapperFilterApplied>
          <WrapperLabel>
            <LabelFilterApplied>{text.labelDoesNotContain}</LabelFilterApplied>
          </WrapperLabel>
          <FilterPills list={allergens} onRemove={onRemove} type='allergens' />
        </WrapperFilterApplied>
      )}
      <WrapperLabel>
        <ButtonClear onClick={clearAll} data-testid='clear-all-button'>
          <LabelClear>{text.labelClearAll}</LabelClear>
        </ButtonClear>
      </WrapperLabel>
    </FilterAllergensPillsContainer>
  )
}

export default FilterAllergensPills
